"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTstcfStrategy = createTstcfStrategy;
const constants_1 = require("../constants");
const validationHelpers_1 = require("../common/validationHelpers");
const TSTCF_PRO_NUMBER_MIN_LENGTH = 10;
const TSTCF_PRO_NUMBER_MAX_LENGTH = 11;
function createTstcfStrategy(options) {
    var _a, _b;
    const { enableCheckDigit, proNumberLengthConstraints } = options;
    const minLength = (_a = proNumberLengthConstraints === null || proNumberLengthConstraints === void 0 ? void 0 : proNumberLengthConstraints.minLength) !== null && _a !== void 0 ? _a : TSTCF_PRO_NUMBER_MIN_LENGTH;
    const maxLength = (_b = proNumberLengthConstraints === null || proNumberLengthConstraints === void 0 ? void 0 : proNumberLengthConstraints.maxLength) !== null && _b !== void 0 ? _b : TSTCF_PRO_NUMBER_MAX_LENGTH;
    const getCheckDigit = (proNumber) => {
        // Pro number will be of 10 digits here
        if (isNaN(Number(proNumber))) {
            return 0;
        }
        // Exclude first 3 digits
        const proIdWithoutFirstThreeDigits = proNumber.slice(3);
        // Take each of last 7 digits as individual and multiply alternatively with 1 and 2
        // Sum of this
        const multipliedSum = proIdWithoutFirstThreeDigits
            .split("")
            .reduce((sum, digit, index) => {
            const multiplier = index % 2 === 0 ? 1 : 2;
            return sum + Number(digit) * multiplier;
        }, 0);
        // Take last digit as check digit
        return Number(multipliedSum.toString().slice(-1));
    };
    const getProNumberWithCheckDigit = ({ proNumber, }) => {
        // TSTCF only validates check digit, doesn't add it
        return proNumber;
    };
    const validateProNumber = (validationInput) => {
        const { proNumber } = validationInput;
        // Note: proNumber is already trimmed by BaseProNumberValidator
        // Note: Format validation (numeric, all zeros, negative, NaN) is already handled by base format validator
        const proNumberLen = proNumber.length;
        // Check minimum length
        if (proNumberLen < minLength) {
            return (0, validationHelpers_1.createValidationError)(constants_1.PRO_VALIDATION_ERROR_TYPES.PRO_NUMBER_MIN, {
                minLength,
            });
        }
        // Check maximum length
        if (proNumberLen > maxLength) {
            return (0, validationHelpers_1.createValidationError)(constants_1.PRO_VALIDATION_ERROR_TYPES.PRO_NUMBER_MAX, {
                maxLength,
            });
        }
        // Check digit validation for 11-digit numbers
        if (enableCheckDigit && proNumberLen === maxLength) {
            // 11 digits: validate check digit
            // First 3 digits are origin designation, last digit is check digit
            const enteredCheckDigit = Number(proNumber.slice(-1));
            // Calculate check digit from first 10 digits (excluding the check digit itself)
            const calculatedCheckDigit = getCheckDigit(proNumber.slice(0, minLength));
            if (enteredCheckDigit !== calculatedCheckDigit) {
                return (0, validationHelpers_1.createValidationError)(constants_1.PRO_VALIDATION_ERROR_TYPES.INVALID_CHECK_DIGIT);
            }
        }
        // 10 digits: no check digit validation required
        return null;
    };
    const isTempProNumber = (proNumber) => {
        return false;
    };
    return {
        getProNumberWithCheckDigit,
        validateProNumber,
        isTempProNumber,
        getCheckDigit,
    };
}
